import * as normalizers from '../../utils/normalizers';
import * as validators from '../../utils/validators';
import { LabeledInput } from './menu-components';
import { DISTANCE_UNITS } from '../../constants/units';
import OffsetIcon from '../icons/OffsetIcon';
import { asRoundedDecimal } from '../../utils/formatters';

const OffsetInput = ({ readonly, updateFieldSection, section }) => {
  return (
    <>
      <LabeledInput
        label={
          <div className="d-flex justify-content-between w-100">
            <div>offset</div>
            <div>X</div>
          </div>
        }
        unitSpec={DISTANCE_UNITS}
        readonly={readonly}
        update={(value) =>
          updateFieldSection(section.id, {
            offsetX: value,
          })
        }
        normalize={normalizers.asFloat}
        isValid={validators.isNumber}
        type="number"
        step={1}
        defaultValue={section.offsetX}
        formatter={asRoundedDecimal}
        className="mr-2"
        icon={<OffsetIcon />}
      />
      <LabeledInput
        label={<div className="w-100 text-right">Y</div>}
        unitSpec={DISTANCE_UNITS}
        readonly={readonly}
        update={(value) =>
          updateFieldSection(section.id, {
            offsetY: value,
          })
        }
        normalize={normalizers.asFloat}
        isValid={validators.isNumber}
        type="number"
        step={1}
        defaultValue={section.offsetY}
        formatter={asRoundedDecimal}
        icon={<div />}
      />
    </>
  );
};

export default OffsetInput;
